// ─────────────────────────────────────────────────────────────
// EDITABLE BUSINESS CONFIGURATION
// Update the values below to change business info across the
// entire website (phone, hours, address, ratings, socials, map).
// ─────────────────────────────────────────────────────────────

const address =
  "8-2-629/1/B, Road No. 12, Mithila Nagar, Banjara Hills, Hyderabad, Telangana 500034, India";

export const site = {
  name: "Glow & Blow",
  fullName: "Glow & Blow Unisex Salon",
  tagline: "Unisex Salon — Banjara Hills, Hyderabad",
  footerDescription:
    "Professional salon and beauty services in Banjara Hills, Hyderabad.",

  phoneDisplay: "+91 73372 30662",
  phoneHref: "tel:+917337230662",
  whatsappNumber: "917337230662",
  whatsappUrl: "https://wa.me/917337230662",
  email: "", // editable — add salon email when available

  address,
  addressLine1: "8-2-629/1/B, Road No. 12, Mithila Nagar",
  addressLine2: "Banjara Hills, Hyderabad, Telangana 500034",
  addressShort: "Banjara Hills, Hyderabad",

  hoursDays: "Monday – Sunday",
  hoursTime: "10:00 AM – 8:30 PM",
  hoursSchema: "Mo-Su 10:00-20:30",

  // Currently published Google rating data (editable)
  rating: { value: 3.9, count: 259 },

  geo: { lat: 17.4126, lng: 78.4325 },
  mapEmbedUrl: `https://www.google.com/maps?q=${encodeURIComponent(address)}&output=embed`,
  directionsUrl: `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`,
  googleReviewsUrl: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    "Glow & Blow Unisex Salon, Banjara Hills, Hyderabad",
  )}`,

  // Editable social placeholders — paste real URLs when available.
  // Empty values render as inactive placeholders.
  social: {
    instagram: "",
    facebook: "",
    googleBusiness: "",
    whatsapp: "https://wa.me/917337230662",
  },

  announcement: {
    text: "Appointments & enquiries — Call or WhatsApp us today",
    cta: "Book an Appointment",
  },
};

export const navLinks = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Gallery", to: "/gallery" },
  { label: "Reviews", to: "/reviews" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];
